import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class SwiperRolloverCard {
    constructor() {
        console.log('%c👍🏼 Swiper Rollover Cards', 'color: yellow');
        
        this.swiperRolloverCards = document.querySelectorAll(
            '.swiper--rollover-cards'
        )
        
    }
    init() {
        this.swiperRolloverCards.forEach((elem, i) => {
            
            let swiper;
            let init = false;
            let wrapper = elem.querySelector('.swiper-wrapper');
            let blurbs = elem.querySelectorAll('.swiper-rollover-cards__card__blurb');

            let onresize = function (e) {
                if (window.innerWidth <= 768) {
                    if (!init) {
                        init = true;
                        wrapper.classList.remove('row');
                        swiper = new Swiper(elem, {
                            slidesPerView: 1.5,
                            loop: true,
                            spaceBetween: 30,
                            speed: 1001,
                            slidesOffsetBefore: '8',
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                            
                            breakpoints: {
                                440: {
                                    slidesPerView: 1.8
                                },
                                540: {
                                    slidesPerView: 2.3
                                }
                            }
                        });   

                        
                        blurbs.forEach((blurb, i) => {
                            blurb.classList.add('show');
                        })


                    } 
                } else if (init) {
                    wrapper.classList.add('row');
                    swiper.destroy();
                    init = false;

                    blurbs.forEach((blurb, i) => {
                        blurb.classList.remove('show');
                    })
                }
            }
            onresize();
            window.addEventListener("resize", onresize);
        })


        let rolloverCards = document.querySelectorAll(
            '.swiper-rollover-cards__card'
        )
        rolloverCards.forEach((elem, i) => {

            let button = elem.querySelector('button');

            button.addEventListener('click', function (e) {
                console.log('rolloverclick');
                let el = this.closest('.swiper-rollover-cards__card__blurb');
                el.classList.toggle('show');
            })
        })
    }
}

